function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire38cb"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire38cb"] = parcelRequire;
}
parcelRequire.register("kReb3", function(module, exports) {

$parcel$export(module.exports, "register", () => $f2f3c12eea468279$export$6503ec6e8aabbaf, (v) => $f2f3c12eea468279$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $f2f3c12eea468279$export$f7ad0328861e2f03, (v) => $f2f3c12eea468279$export$f7ad0328861e2f03 = v);
var $f2f3c12eea468279$export$6503ec6e8aabbaf;
var $f2f3c12eea468279$export$f7ad0328861e2f03;
"use strict";
var $f2f3c12eea468279$var$mapping = {};
function $f2f3c12eea468279$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$f2f3c12eea468279$var$mapping[keys[i]] = pairs[keys[i]];
}
function $f2f3c12eea468279$var$resolve(id) {
    var resolved = $f2f3c12eea468279$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$f2f3c12eea468279$export$6503ec6e8aabbaf = $f2f3c12eea468279$var$register;
$f2f3c12eea468279$export$f7ad0328861e2f03 = $f2f3c12eea468279$var$resolve;

});

var $d017969104339a62$exports = {};

(parcelRequire("kReb3")).register(JSON.parse('{"aOaNm":"index.61c7d992.js","9cDX8":"chef.3d0539aa.png","gwCVZ":"Instamart.a9c15cbf.js","gKhPL":"About.e21a31c7.js","dQVK0":"index.0a34c9b5.css"}'));


//# sourceMappingURL=index.9e2a5ed3.js.map
